import React, { useState, useEffect, useCallback } from 'react';
import './Gallery.css';

const Gallery = () => {
  // Gallery sections configuration
  const gallerySections = [
    { 
      id: 1, 
      title: 'Double Bed Room', 
      description: 'Comfortable double bed accommodation', 
      image: '/images/gallery/double-bed/main.jpg',
      folder: 'double-bed',
      images: [
        '/images/gallery/double-bed/main.jpg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.42 (1).jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.43.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.47.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.48.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.49 (1).jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.52.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.55.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.56.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.02.57.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.03.00.jpeg',
        '/images/gallery/double-bed/WhatsApp Image 2025-11-29 at 00.03.02.jpeg'
      ]
    },
    { 
      id: 2, 
      title: 'Four-Person Room', 
      description: 'Spacious family room', 
      image: '/images/gallery/four-person/main.jpg',
      folder: 'four-person',
      images: [
        '/images/gallery/four-person/main.jpg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.16 (1).jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.17.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.23.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.24 (1).jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.26.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.28.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.33.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.35 (1).jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.36.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.39.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.41.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.44.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.45 (1).jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.51.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.53.jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.56 (1).jpeg',
        '/images/gallery/four-person/WhatsApp Image 2025-11-29 at 00.02.58.jpeg'
      ]
    },
    { 
      id: 3, 
      title: 'Group Hall', 
      description: 'Large hall for gatherings (12 person capacity)', 
      image: '/images/gallery/group-hall/main.jpg',
      folder: 'group-hall',
      images: [
        '/images/gallery/group-hall/main.jpg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.01 (1).jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.20.jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.22.jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.25.jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.33 (1).jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.37.jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.38.jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.39 (1).jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.49.jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.53 (1).jpeg',
        '/images/gallery/group-hall/WhatsApp Image 2025-11-29 at 00.02.59.jpeg'
      ]
    },
    { 
      id: 4, 
      title: 'Hotel Exterior', 
      description: 'Beautiful location in Ujjain', 
      image: '/images/gallery/exterior/main.jpg',
      folder: 'exterior',
      images: [
        '/images/gallery/exterior/main.jpg',
        '/images/gallery/exterior/WhatsApp Image 2025-11-29 at 00.02.13.jpeg',
        '/images/gallery/exterior/WhatsApp Image 2025-11-29 at 00.02.34.jpeg',
        '/images/gallery/exterior/WhatsApp Image 2025-11-29 at 00.02.50.jpeg',
        '/images/gallery/exterior/WhatsApp Image 2025-11-29 at 00.02.58 (1).jpeg',
        '/images/gallery/exterior/WhatsApp Image 2025-11-29 at 00.03.02 (1).jpeg'
      ]
    },
    { 
      id: 5, 
      title: 'Modern Amenities', 
      description: 'AC, TV, WiFi, and more', 
      image: '/images/gallery/amenities/main.jpg',
      folder: 'amenities',
      images: [
        '/images/gallery/amenities/main.jpg',
        '/images/gallery/amenities/WhatsApp Image 2025-11-29 at 00.02.18.jpeg',
        '/images/gallery/amenities/WhatsApp Image 2025-11-29 at 00.02.19.jpeg',
        '/images/gallery/amenities/WhatsApp Image 2025-11-29 at 00.02.20 (1).jpeg',
        '/images/gallery/amenities/WhatsApp Image 2025-11-29 at 00.02.30.jpeg',
        '/images/gallery/amenities/WhatsApp Image 2025-11-29 at 00.02.40.jpeg'
      ]
    },
    { 
      id: 6, 
      title: 'Clean Facilities', 
      description: 'Well-maintained rooms and bathrooms', 
      image: '/images/gallery/facilities/main.jpg',
      folder: 'facilities',
      images: [
        '/images/gallery/facilities/main.jpg',
        '/images/gallery/facilities/WhatsApp Image 2025-11-29 at 00.01.59.jpeg',
        '/images/gallery/facilities/WhatsApp Image 2025-11-29 at 00.02.14 (1).jpeg',
        '/images/gallery/facilities/WhatsApp Image 2025-11-29 at 00.02.14.jpeg',
        '/images/gallery/facilities/WhatsApp Image 2025-11-29 at 00.02.16.jpeg',
        '/images/gallery/facilities/WhatsApp Image 2025-11-29 at 00.02.24.jpeg',
        '/images/gallery/facilities/WhatsApp Image 2025-11-29 at 00.02.46.jpeg',
        '/images/gallery/facilities/WhatsApp Image 2025-11-29 at 00.03.01.jpeg'
      ]
    }
  ];

  const [selectedSection, setSelectedSection] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});

  // Handle opening gallery section
  const handleOpenGallery = (section) => {
    setSelectedSection(section);
    setCurrentImageIndex(0);
  };

  // Handle closing gallery modal
  const handleCloseGallery = useCallback(() => {
    setSelectedSection(null);
    setCurrentImageIndex(0);
  }, []);

  // Handle next image
  const handleNextImage = useCallback(() => {
    if (selectedSection) {
      setCurrentImageIndex((prev) => 
        prev < selectedSection.images.length - 1 ? prev + 1 : 0
      );
    }
  }, [selectedSection]);

  // Handle previous image
  const handlePrevImage = useCallback(() => {
    if (selectedSection) {
      setCurrentImageIndex((prev) => 
        prev > 0 ? prev - 1 : selectedSection.images.length - 1
      );
    }
  }, [selectedSection]);

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!selectedSection) return;
      
      if (e.key === 'Escape') {
        handleCloseGallery();
      } else if (e.key === 'ArrowRight') {
        handleNextImage();
      } else if (e.key === 'ArrowLeft') {
        handlePrevImage();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [selectedSection, handleNextImage, handlePrevImage, handleCloseGallery]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (selectedSection) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedSection]);

  // Handle image load
  const handleImageLoad = (imagePath) => {
    setLoadedImages(prev => ({ ...prev, [imagePath]: true }));
  };

  return (
    <>
      <section id="gallery" className="gallery section">
        <div className="container">
          <h2 className="section-title">Gallery</h2>
          <p className="section-subtitle">Explore Our Rooms and Facilities</p>
          
          <div className="gallery-grid">
            {gallerySections.map(section => (
              <div 
                key={section.id} 
                className="gallery-item"
                onClick={() => handleOpenGallery(section)}
              >
                <div className="gallery-image">
                  <img 
                    src={section.image} 
                    alt={section.title} 
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }} 
                  />
                  <div className="image-placeholder" style={{display: 'none'}}>
                    <span>{section.title}</span>
                  </div>
                  <div className="gallery-overlay">
                    <h4>{section.title}</h4>
                    <p>{section.description}</p>
                    <div className="gallery-click-hint">Click to view all images</div>
                  </div>
                </div>
                <div className="gallery-card-title">
                  <h4>{section.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Modal */}
      {selectedSection && (
        <div className="gallery-modal" onClick={handleCloseGallery}>
          <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-modal-close" onClick={handleCloseGallery}>
              ×
            </button>
            
            <div className="gallery-modal-header">
              <h2>{selectedSection.title}</h2>
              <p className="gallery-modal-counter" aria-live="polite" aria-atomic="true">
                Image {currentImageIndex + 1} of {selectedSection.images.length}
              </p>
              <p className="gallery-modal-hint" style={{fontSize: '0.85rem', color: 'var(--text-light)', marginTop: '5px'}}>
                Use arrow keys or click navigation buttons to browse
              </p>
            </div>

            <div className="gallery-modal-main">
              <button 
                className="gallery-modal-nav gallery-modal-prev" 
                onClick={handlePrevImage}
                aria-label="Previous image"
              >
                ‹
              </button>
              
              <div className="gallery-modal-image-container">
                {!loadedImages[selectedSection.images[currentImageIndex]] && (
                  <div className="image-loading" aria-label="Loading image" role="status">
                    <span>Loading image...</span>
                  </div>
                )}
                <img 
                  src={selectedSection.images[currentImageIndex]} 
                  alt={`${selectedSection.title} - Image ${currentImageIndex + 1} of ${selectedSection.images.length}`}
                  onLoad={() => handleImageLoad(selectedSection.images[currentImageIndex])}
                  onError={() => {
                    setLoadedImages(prev => ({ 
                      ...prev, 
                      [selectedSection.images[currentImageIndex]]: false 
                    }));
                  }}
                  style={{ 
                    display: loadedImages[selectedSection.images[currentImageIndex]] ? 'block' : 'none' 
                  }}
                />
              </div>
              
              <button 
                className="gallery-modal-nav gallery-modal-next" 
                onClick={handleNextImage}
                aria-label="Next image"
              >
                ›
              </button>
            </div>

            <div className="gallery-modal-thumbnails">
              {selectedSection.images.map((image, index) => (
                <div
                  key={index}
                  className={`gallery-thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                >
                  <img 
                    src={image} 
                    alt={`Thumbnail ${index + 1}`}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;

